module.exports = __webpack_public_path__ + "assets/img/cancel.a355a85b.svg";